import {createConsumer} from '@rails/actioncable'

const cable = createConsumer()
export default cable
